import { render, staticRenderFns } from "./DialogHeader.vue?vue&type=template&id=0897d536&scoped=true&"
import script from "./DialogHeader.vue?vue&type=script&lang=js&"
export * from "./DialogHeader.vue?vue&type=script&lang=js&"
import style0 from "./DialogHeader.vue?vue&type=style&index=0&id=0897d536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897d536",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardTitle})
